import { render, staticRenderFns } from "./IconSvgForums.vue?vue&type=template&id=2479a624&scoped=true&"
import script from "./IconSvgForums.vue?vue&type=script&lang=js&"
export * from "./IconSvgForums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2479a624",
  null
  
)

export default component.exports